module.exports = __webpack_public_path__ + "static/media/Inter-MediumItalic.afed191b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-MediumItalic.woff
// module id = 699
// module chunks = 21